"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripLogForHook = exports.tripLogDeserialize = void 0;
const ObjectLog_1 = require("./ObjectLog");
exports.tripLogDeserialize = ObjectLog_1.objectLogDeserialize;
exports.tripLogForHook = ObjectLog_1.objectLogForHook;
